module.exports = __webpack_public_path__ + "static/media/highway-blur-dark.c5b6187c.jpg";